import { SettingsPage } from '@features/preferences/components/SettingsPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/preferences')({ component: SettingsPage });
